import { render, staticRenderFns } from "./Redaction.vue?vue&type=template&id=238d31bd&"
import script from "./Redaction.vue?vue&type=script&lang=ts&"
export * from "./Redaction.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./Redaction.vue?vue&type=style&index=0&id=238d31bd&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-wizard/mfe-ca-wizard/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238d31bd')) {
      api.createRecord('238d31bd', component.options)
    } else {
      api.reload('238d31bd', component.options)
    }
    module.hot.accept("./Redaction.vue?vue&type=template&id=238d31bd&", function () {
      api.rerender('238d31bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Redaction.vue"
export default component.exports